import { useEffect, useState } from "react";
import SamplePassport from "./SamplePassport";
import logo from "../assets/Provinyx-logo-w.png";

const DM_CSS = `
.dm-root{
  --page:#EEF2F9; --white:#FFFFFF; --canvas:#F6F8FC;
  --ink:#0E1A3A; --ink-2:#3A4563; --muted:#6B7590; --label:#8B93A8;
  --line:#E6EBF4; --line-2:#D5DDEB;
  --blue:#2F57E6; --blue-deep:#2447C8; --blue-tint:#EAF0FF; --blue-tint-2:#F4F7FF;
  --navy:#101A38;
  --ok:#0E7A4A; --ok-bg:#E9F5EE; --ok-line:#C3E3D1;
  --amber:#9A6A05; --amber-bg:#FCF3DF; --amber-line:#EFDCAE;
  --t-blue:#EEF3FF; --t-white:#FAFBFE; --t-lilac:#F2F0FC; --t-cream:#FDF5E9; --t-mint:#ECF7F0; --t-pink:#FDEEF0;
  --fd:'Inter',system-ui,-apple-system,'Segoe UI',sans-serif;
  --fm:ui-monospace,'SF Mono',Menlo,monospace;
  background:var(--page);color:var(--ink);font-family:var(--fd);line-height:1.5;padding:24px 16px 28px;-webkit-font-smoothing:antialiased;
}
.dm-root *{box-sizing:border-box}
.dm-root h1,.dm-root h2,.dm-root h3,.dm-root h4{font-family:var(--fd);margin:0;letter-spacing:-.01em;font-weight:700}
.dm-root p{margin:0}
.dm-root button{font:inherit;color:inherit;border:none;background:none;cursor:default}
.dm-root .num{font-variant-numeric:tabular-nums}
.dm-root svg.i{fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}
.dm-root .wrap{max-width:1100px;margin:0 auto;position:relative}
.dm-root .frame{position:absolute;top:0;left:0;width:1100px;height:684px;transform-origin:0 0;background:var(--white);border-radius:16px;box-shadow:0 0 0 1px rgba(14,26,58,.06),0 0 44px rgba(14,26,58,.18),0 8px 30px rgba(14,26,58,.10);overflow:hidden}
.dm-root .bar{display:flex;align-items:center;gap:14px;height:44px;padding:0 18px;background:var(--canvas);border-bottom:1px solid var(--line)}
.dm-root .dots{display:flex;gap:7px;flex:none}
.dm-root .dots i{width:11px;height:11px;border-radius:50%;display:block}
.dm-root .url{flex:1;max-width:440px;margin:0 auto;background:var(--white);border:1px solid var(--line);border-radius:20px;padding:4px 14px;font-size:11.5px;color:var(--muted);font-family:var(--fm);text-align:center;white-space:nowrap;overflow:hidden}
.dm-root .url b{color:var(--ink-2);font-weight:500}
.dm-root .app{display:flex;flex-direction:column;height:640px}
.dm-root .app.off{display:none}
.dm-root .topnav{height:62px;flex:none;display:flex;align-items:center;padding:0 22px 0 20px;background:#336BE1;color:#fff}
.dm-root .logo{height:27px;width:auto;display:block}
.dm-root .tnav{margin-left:auto;display:flex;gap:6px}
.dm-root .nav{display:flex;flex-direction:column;align-items:center;gap:3px;padding:6px 10px;border-radius:10px;font-size:11px;font-weight:500;letter-spacing:.04em;color:#fff;transition:transform .12s}
.dm-root .nav svg{width:20px;height:20px;stroke-width:2.3}
.dm-root .vp{flex:1;min-height:0;overflow-y:auto;scrollbar-width:none;position:relative;background:var(--page)}
.dm-root .vp::-webkit-scrollbar{display:none}
.dm-root .view{display:none;padding:20px 24px 26px}
.dm-root .view.on{display:block;animation:dm-fadein .35s ease}
@keyframes dm-fadein{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
.dm-root .btn{display:inline-flex;align-items:center;gap:6px;white-space:nowrap;border:1px solid var(--line);border-radius:10px;padding:7px 12px;font-size:12px;font-weight:600;background:var(--white);color:var(--ink);box-shadow:0 1px 3px rgba(14,26,58,.04);transition:transform .12s,filter .12s,background .2s}
.dm-root .btn svg{width:14px;height:14px}
.dm-root .btn.pri{background:var(--blue);border-color:var(--blue);color:#fff}
.dm-root .btn[disabled]{background:var(--line);border-color:var(--line);color:var(--muted);box-shadow:none}
.dm-root .btn.okb{background:var(--ok);border-color:var(--ok);color:#fff}
.dm-root .edit{display:inline-flex;align-items:center;gap:7px;background:var(--navy);color:#fff;border-radius:11px;padding:8px 14px;font-size:12px;font-weight:600;transition:transform .12s,filter .12s}
.dm-root .edit svg{width:14px;height:14px}
.dm-root .pressed{transform:scale(.96);filter:brightness(.94)}
.dm-root .tile{border-radius:14px;padding:12px 14px;min-height:66px;display:flex;flex-direction:column;justify-content:center;text-align:left;width:100%}
.dm-root .tlab{display:flex;align-items:center;gap:6px;font-size:9.5px;font-weight:600;letter-spacing:.09em;text-transform:uppercase;color:var(--label);margin-bottom:5px}
.dm-root .tlab svg{width:11px;height:11px;flex:none}
.dm-root .tval{font-size:15.5px;font-weight:700;color:var(--ink);line-height:1.2;font-variant-numeric:tabular-nums}
.dm-root .t-blue{background:var(--t-blue)} .dm-root .t-white{background:var(--t-white);box-shadow:inset 0 0 0 1px var(--line)} .dm-root .t-lilac{background:var(--t-lilac)}
.dm-root .t-cream{background:var(--t-cream)} .dm-root .t-mint{background:var(--t-mint)} .dm-root .t-pink{background:var(--t-pink)}
.dm-root .tile.miss{background:var(--white);box-shadow:inset 0 0 0 1.5px var(--line-2);border:none;transition:background .2s,transform .12s}
.dm-root .tile.miss .tval{color:var(--blue);font-size:13.5px}
.dm-root .tile.fresh{animation:dm-fresh .9s ease}
@keyframes dm-fresh{0%{box-shadow:0 0 0 3px var(--blue)}100%{box-shadow:0 0 0 0 transparent}}
@keyframes dm-slidein{from{opacity:0;transform:translateX(10px)}to{opacity:1;transform:none}}
.dm-root .overlay{position:absolute;left:0;right:0;top:44px;bottom:0;background:rgba(14,26,58,.28);display:none;place-items:center;z-index:40}
.dm-root .overlay.on{display:grid;animation:dm-fadein .25s ease}
.dm-root .card{background:var(--white);border-radius:18px;width:430px;padding:22px 22px 18px;box-shadow:0 18px 50px rgba(14,26,58,.22)}
.dm-root .card h3{font-size:17px}
.dm-root .card .cs{font-size:12px;color:var(--muted);margin:3px 0 14px}
.dm-root .cardfoot{display:flex;justify-content:flex-end;gap:8px;margin-top:20px}
#dm-v-cap{padding:0 0 20px}
.dm-root .dsub{position:sticky;top:0;z-index:5;background:var(--page);display:grid;grid-template-columns:auto 1fr auto;align-items:center;gap:12px;padding:12px 20px 12px}
.dm-root .dsub .did{justify-self:center}
.dm-root .back{display:flex;align-items:center;gap:7px;font-weight:700;font-size:13.5px;color:var(--ink)}
.dm-root .back svg{width:15px;height:15px}
.dm-root .did{font-weight:700;font-size:13.5px;color:var(--ink);display:flex;align-items:center;gap:9px;white-space:nowrap}
.dm-root .did b{color:var(--blue)}
.dm-root .badge{font-size:9.5px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;padding:2px 9px;border-radius:20px;background:var(--amber-bg);color:var(--amber);border:1px solid var(--amber-line)}
.dm-root .badge.pubd{background:var(--ok-bg);color:var(--ok);border-color:var(--ok-line)}
.dm-root .dsub .sp{display:flex;gap:7px;align-items:center;justify-content:flex-end}
.dm-root .saved{font-size:11.5px;color:var(--ok);font-weight:500;white-space:nowrap}
.dm-root .dbody{display:grid;grid-template-columns:186px 1fr 228px;gap:14px;padding:0 20px;align-items:start}
.dm-root .srail{display:flex;flex-direction:column;gap:3px}
.dm-root .prog{background:var(--white);border-radius:14px;padding:10px 12px;margin-bottom:8px;box-shadow:0 4px 16px rgba(14,26,58,.05)}
.dm-root .prog .lbl{display:flex;justify-content:space-between;align-items:baseline;font-size:10.5px;margin-bottom:6px;color:var(--muted)}
.dm-root .prog .lbl b{font-size:11.5px;color:var(--ink);font-variant-numeric:tabular-nums}
.dm-root .track{height:6px;background:var(--canvas);border-radius:5px;overflow:hidden}
.dm-root .track i{display:block;height:100%;background:var(--blue);border-radius:5px;transition:width .35s ease}
.dm-root .track.full i{background:var(--ok)}
.dm-root .steps{display:flex;flex-direction:column;gap:3px}
.dm-root .sitem{display:grid;grid-template-columns:18px 1fr;gap:10px;align-items:center;padding:8px 10px;border-radius:12px;color:var(--ink-2);transition:background .25s,color .25s,box-shadow .25s}
.dm-root .sitem svg{width:16px;height:16px;color:#8590A8}
.dm-root .sitem .sn{font-size:11.5px;font-weight:600;line-height:1.25;display:block}
.dm-root .sitem .ss{font-size:9.5px;font-weight:500;color:var(--muted);display:block;margin-top:1px;font-variant-numeric:tabular-nums}
.dm-root .sitem.done .ss{color:var(--ok)}
.dm-root .sitem.now .ss,.dm-root .sitem.part .ss{color:var(--blue)}
.dm-root .sitem.act{background:var(--blue);color:#fff;box-shadow:0 10px 22px rgba(47,87,230,.32)}
.dm-root .sitem.act svg{color:#fff}
.dm-root .sitem.act .ss{color:rgba(255,255,255,.82)}
.dm-root .mcard{background:var(--white);border-radius:22px;padding:20px 22px 22px;box-shadow:0 10px 32px rgba(14,26,58,.06)}
.dm-root .mhead{display:flex;align-items:center;gap:10px}
.dm-root .mhead h1{font-size:22px;text-wrap:balance}
.dm-root .star{width:28px;height:28px;border-radius:50%;box-shadow:inset 0 0 0 1px var(--line);display:grid;place-items:center;flex:none;color:#C2CADB}
.dm-root .star svg{width:14px;height:14px}
.dm-root .mact{margin-left:auto;display:flex;gap:7px;flex:none}
.dm-root .mdesc{font-size:12.5px;color:var(--muted);margin:4px 0 16px}
.dm-root .tiles{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.dm-root .ppanel{background:var(--white);border-radius:22px;padding:12px;box-shadow:0 10px 32px rgba(14,26,58,.06)}
.dm-root .pimgbox{background:var(--canvas);border-radius:16px;height:92px;display:grid;place-items:center;margin-bottom:6px}
.dm-root .pimgbox svg{height:70px;width:auto}
.dm-root .prow{display:flex;align-items:center;gap:10px;padding:6px 2px}
.dm-root .picon{width:32px;height:32px;border-radius:10px;display:grid;place-items:center;flex:none}
.dm-root .picon svg{width:16px;height:16px}
.dm-root .pi-blue{background:#EAF0FF;color:var(--blue)} .dm-root .pi-lilac{background:#F0EEFB;color:#6B5BD0}
.dm-root .plab{font-size:9px;font-weight:600;letter-spacing:.09em;text-transform:uppercase;color:var(--label)}
.dm-root .pval{font-size:12px;font-weight:700;color:var(--ink);line-height:1.25}
.dm-root .lifeh{display:flex;align-items:center;gap:8px;margin:10px 2px 4px;padding-top:10px;border-top:1px solid var(--line)}
.dm-root .lifeh h3{font-size:12px}
.dm-root .livebadge{display:inline-flex;align-items:center;gap:5px;font-size:8.5px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--ok);background:var(--ok-bg);border:1px solid var(--ok-line);padding:1px 7px;border-radius:20px}
.dm-root .livebadge i{width:6px;height:6px;border-radius:50%;background:var(--ok);animation:dm-pulse 1.8s ease-in-out infinite}
@keyframes dm-pulse{0%,100%{opacity:1}50%{opacity:.25}}
.dm-root .vstages{position:relative;padding:0 2px}
.dm-root .vstages::before{content:'';position:absolute;left:14px;top:20px;bottom:20px;width:2px;background:var(--line-2)}
.dm-root .stage{display:grid;grid-template-columns:26px 1fr auto;gap:9px;align-items:center;padding:5px 0;position:relative}
.dm-root .stage .dot{width:26px;height:26px;border-radius:50%;display:grid;place-items:center;font-size:10.5px;font-weight:600;background:var(--white);border:2px solid var(--line-2);color:var(--muted);position:relative;z-index:1;box-shadow:0 0 0 3px var(--white);transition:background .3s,border-color .3s,color .3s}
.dm-root .st-done .dot{background:var(--ok);border-color:var(--ok);color:#fff}
.dm-root .st-part .dot{border-color:var(--blue);color:var(--blue)}
.dm-root .st-now .dot{background:var(--blue);border-color:var(--blue);color:#fff;box-shadow:0 0 0 3px var(--white),0 0 0 6px var(--blue-tint)}
.dm-root .stage .sb{min-width:0}
.dm-root .stage b{font-size:11.5px;font-weight:600;display:block;line-height:1.2}
.dm-root .stage .state{font-size:8.5px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--muted);display:block}
.dm-root .st-done .state{color:var(--ok)} .dm-root .st-now .state,.dm-root .st-part .state{color:var(--blue)}
.dm-root .stage .mini{display:block;height:3px;background:var(--canvas);border-radius:3px;overflow:hidden;margin-top:3px}
.dm-root .stage .mini i{display:block;height:100%;background:var(--blue);transition:width .35s ease}
.dm-root .st-done .mini i{background:var(--ok)}
.dm-root .stage .fc{font-size:10px;font-weight:600;color:var(--muted);font-variant-numeric:tabular-nums}
.dm-root .bump .dot{animation:dm-bump .6s ease}
@keyframes dm-bump{0%{transform:scale(1)}40%{transform:scale(1.22)}100%{transform:scale(1)}}
.dm-root .notice{position:absolute;right:20px;top:112px;width:290px;background:var(--white);border-radius:14px;box-shadow:0 12px 30px rgba(14,26,58,.16);padding:12px 14px;display:flex;gap:11px;z-index:30;transform:translateX(330px);transition:transform .45s cubic-bezier(.3,.1,.2,1)}
.dm-root .notice.on{transform:none}
.dm-root .notice .ic{width:30px;height:30px;border-radius:9px;background:var(--ok-bg);color:var(--ok);display:grid;place-items:center;flex:none}
.dm-root .notice b{font-size:12.5px;display:block}
.dm-root .notice span{font-size:11px;color:var(--muted)}
.dm-root .toast{position:absolute;left:50%;bottom:22px;transform:translate(-50%,16px);background:var(--navy);color:#fff;font-size:12.5px;font-weight:500;padding:9px 16px;border-radius:11px;opacity:0;transition:opacity .25s,transform .25s;z-index:45;white-space:nowrap}
.dm-root .toast.on{opacity:1;transform:translate(-50%,0)}
.dm-root .pubcard{text-align:center;width:380px}
.dm-root .pubcard .okc{width:42px;height:42px;border-radius:50%;background:var(--ok);color:#fff;display:grid;place-items:center;margin:0 auto 10px;font-size:18px}
.dm-root .qrbox{width:150px;height:150px;margin:16px auto 6px;border:1px solid var(--line);border-radius:12px;padding:10px}
.dm-root .qr rect.m{opacity:0;transition:opacity .25s}
.dm-root .qr.show rect.m{opacity:1}
.dm-root .pubcard .cs{margin-bottom:0}
.dm-root .pubcard .cardfoot{justify-content:center}
.dm-root .public{display:none;height:640px;background:var(--page);overflow:hidden}
.dm-root .public.on{display:block;animation:dm-fadein .4s ease}
.dm-root .ph{display:flex;align-items:center;gap:10px;height:62px;padding:0 30px 0 20px;background:#336BE1;color:#fff}
.dm-root .ph .plogo{height:27px;width:auto;display:block}
.dm-root .ph .phs{font-size:12px;font-weight:500;letter-spacing:.04em;color:rgba(255,255,255,.88);padding-left:12px;margin-left:2px;border-left:1px solid rgba(255,255,255,.35)}
.dm-root .ph .ver{margin-left:auto;font-size:11px;font-weight:600;color:var(--ok);background:#fff;padding:4px 11px;border-radius:20px}
.dm-root .ph .scan{font-size:10.5px;color:rgba(255,255,255,.85);margin-left:12px}
.dm-root .pbody{padding:18px 30px;display:flex;flex-direction:column;gap:12px}
.dm-root .phero{display:flex;gap:20px;align-items:center;background:var(--white);border-radius:18px;padding:16px 20px;box-shadow:0 8px 28px rgba(14,26,58,.06)}
.dm-root .phero .cat{font-size:9.5px;font-weight:600;letter-spacing:.09em;text-transform:uppercase;color:var(--blue);background:var(--blue-tint);padding:3px 9px;border-radius:6px}
.dm-root .phero h2{font-size:22px;margin:7px 0 3px}
.dm-root .phero .pm{font-size:12px;color:var(--muted)}
.dm-root .phero .pm b{color:var(--blue);font-weight:600}
.dm-root .phero .qrs{margin-left:auto;width:80px;height:80px;border:1px solid var(--line);border-radius:10px;padding:6px;flex:none}
.dm-root .facts6{display:grid;grid-template-columns:repeat(6,1fr);gap:10px}
.dm-root .fact{border-radius:14px;padding:11px 12px;transition:box-shadow .3s}
.dm-root .fact .k{font-size:9px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--label);line-height:1.35}
.dm-root .fact .v{font-size:19px;font-weight:700;margin-top:4px;font-variant-numeric:tabular-nums}
.dm-root .fact .v small{font-size:10.5px;font-weight:500;color:var(--muted)}
.dm-root .fact.hot{box-shadow:0 0 0 2px var(--blue)}
.dm-root .plife{display:grid;grid-template-columns:1.6fr 1fr;gap:12px}
.dm-root .pbox{background:var(--white);border-radius:18px;padding:14px 16px;box-shadow:0 8px 28px rgba(14,26,58,.06)}
.dm-root .pbox h3{font-size:13.5px;margin-bottom:2px}
.dm-root .pbox .ps{font-size:11px;color:var(--muted)}
.dm-root .tl{position:relative;padding-top:34px;margin-top:4px}
.dm-root .loop{position:absolute;top:8px;left:10%;right:10%;height:26px;border:1.5px dashed var(--blue);border-bottom:none;border-radius:11px 11px 0 0}
.dm-root .loop-lbl{position:absolute;top:-8px;left:50%;transform:translateX(-50%);background:var(--white);padding:0 8px;font-size:10px;color:var(--blue);font-style:italic;white-space:nowrap}
.dm-root .loop-arr{position:absolute;left:-6px;bottom:-4px;border-left:5.5px solid transparent;border-right:5.5px solid transparent;border-top:8px solid var(--blue)}
.dm-root .tl.looped .loop{border-style:solid;animation:dm-glow 1.2s ease}
@keyframes dm-glow{0%{box-shadow:0 0 0 0 var(--blue-tint)}50%{box-shadow:0 -4px 12px 2px var(--blue-tint)}100%{box-shadow:none}}
.dm-root .rail{position:absolute;top:47px;left:10%;right:10%;height:3px;display:grid;grid-template-columns:repeat(4,1fr)}
.dm-root .seg{height:3px;background:var(--line-2);position:relative;transition:background .4s}
.dm-root .seg.on{background:var(--ok)}
.dm-root .seg::after{content:'›';position:absolute;left:50%;top:50%;transform:translate(-50%,-56%);font-size:14px;line-height:1;color:var(--muted);background:var(--white);padding:0 4px}
.dm-root .seg.on::after{color:var(--ok)}
.dm-root .stages{display:grid;grid-template-columns:repeat(5,1fr)}
.dm-root .pst{display:flex;flex-direction:column;align-items:center;text-align:center}
.dm-root .pst .dot{width:28px;height:28px;border-radius:50%;background:var(--white);border:2px solid var(--line-2);position:relative;z-index:1;box-shadow:0 0 0 5px var(--white);display:grid;place-items:center;font-size:11px;color:#fff;transition:all .4s}
.dm-root .pst.past .dot{background:var(--ok);border-color:var(--ok)}
.dm-root .pst.here .dot{background:var(--blue);border-color:var(--blue);box-shadow:0 0 0 5px var(--white),0 0 0 10px var(--blue-tint)}
.dm-root .pst b{font-size:11.5px;margin-top:8px}
.dm-root .pst span{font-size:10px;color:var(--muted)}
.dm-root .pst.here span{color:var(--blue);font-weight:600}
.dm-root .events{display:flex;flex-direction:column;margin-top:8px}
.dm-root .ev{display:flex;gap:9px;padding:6px 0;border-bottom:1px dashed var(--line);font-size:11.5px;line-height:1.4;animation:dm-slidein .4s ease}
.dm-root .ev:last-child{border-bottom:none}
.dm-root .ev i{font-style:normal;font-size:10.5px;font-weight:600;color:var(--blue);flex:none;padding-top:1px}
.dm-root .cursor{position:absolute;left:560px;top:600px;width:22px;height:26px;z-index:100;pointer-events:none;transition:left var(--d,500ms) cubic-bezier(.45,.05,.25,1),top var(--d,500ms) cubic-bezier(.45,.05,.25,1),transform .12s;filter:drop-shadow(0 2px 3px rgba(14,26,58,.3))}
.dm-root .cursor.down{transform:scale(.84)}
.dm-root .ripple{position:absolute;width:32px;height:32px;margin:-16px 0 0 -16px;border-radius:50%;background:rgba(47,87,230,.3);z-index:99;pointer-events:none;animation:dm-rip .55s forwards}
@keyframes dm-rip{from{transform:scale(.3);opacity:1}to{transform:scale(1.9);opacity:0}}
.dm-root .player{max-width:1100px;margin:18px auto 0;display:flex;align-items:center;gap:16px;flex-wrap:wrap;justify-content:center}
.dm-root .pdots{display:flex;gap:7px;align-items:center}
.dm-root .pd{width:9px;height:9px;border-radius:5px;background:var(--line-2);cursor:pointer;transition:width .3s,background .3s}
.dm-root .pd.on{width:30px;background:var(--blue)}
.dm-root .pd:focus-visible,.dm-root .pp:focus-visible{outline:2px solid var(--blue);outline-offset:3px}
.dm-root .pp{width:34px;height:34px;border-radius:50%;background:var(--white);border:1px solid var(--line-2);display:grid;place-items:center;font-size:12px;cursor:pointer;color:var(--ink)}
.dm-root .pcap{min-width:0;flex:1 1 360px;max-width:560px}
.dm-root .pcap b{font-size:14px;display:block}
.dm-root .pcap span{font-size:12.5px;color:var(--muted)}
.dm-root .note{text-align:center;font-size:10.5px;color:var(--muted);margin-top:14px}
.dm-root.dm-embed{background:transparent;padding:0}
.dm-root.dm-embed .player{display:none}
@media (prefers-reduced-motion:reduce){.dm-root *{transition:none!important;animation:none!important}}
`;

// Props (all optional):
//   embedded   – hero use: transparent background, no player controls
//   whiteBg    – white page background around the browser frame (default: on when NOT embedded)
//   maxWidth   – max width of the mockup in px (default: 940 on the home page, 1100 when embedded)
export default function DashboardMockup({ embedded = false, whiteBg = !embedded, maxWidth = embedded ? 1100 : 940 }) {
  const [showSample, setShowSample] = useState(false);

  useEffect(() => {
    const wrap = document.getElementById('dm-wrap');
    const frame = document.getElementById('dm-frame');
    let SCALE = 1;
    function fit() {
      SCALE = Math.min(1, wrap.clientWidth / 1100);
      frame.style.transform = `scale(${SCALE})`;
      wrap.style.height = (684 * SCALE) + 'px';
    }
    window.addEventListener('resize', fit);
    fit();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(fit) : null;
    if (ro) ro.observe(wrap);
    let io = null;

    const $ = id => document.getElementById('dm-' + id);
    const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;

    class Cancel extends Error {}
    let token = 0, paused = RM, waiters = [];
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    function check(t) { if (t !== token) throw new Cancel(); }
    async function wait(ms, t) {
      let left = ms;
      while (left > 0) {
        check(t);
        if (paused) { await new Promise(r => waiters.push(r)); continue; }
        const s = Math.min(left, 60); await sleep(s); left -= s;
      }
      check(t);
    }
    function setPaused(p) {
      paused = p;
      $('pp').textContent = p ? '▶' : '❚❚';
      $('pp').setAttribute('aria-label', p ? 'Play' : 'Pause');
      if (!p) waiters.splice(0).forEach(r => r());
    }

    const cur = $('cur'), vp = $('vp');
    let cx = 560, cy = 600;
    function place(x, y, dur) { cur.style.setProperty('--d', (RM ? 0 : dur) + 'ms'); cur.style.left = (x - 2) + 'px'; cur.style.top = (y - 2) + 'px'; cx = x; cy = y; }
    function pointOf(el) {
      const r = el.getBoundingClientRect(), f = frame.getBoundingClientRect();
      return [(r.left + r.width / 2 - f.left) / SCALE, (r.top + r.height / 2 - f.top) / SCALE];
    }
    async function reveal(el, t) {
      if (!vp.contains(el)) return;
      const er = el.getBoundingClientRect(), vr = vp.getBoundingClientRect();
      if (er.top < vr.top + 70 * SCALE || er.bottom > vr.bottom - 40 * SCALE) {
        const target = vp.scrollTop + (er.top - vr.top) / SCALE - 260;
        vp.scrollTo({ top: Math.max(0, target), behavior: RM ? 'auto' : 'smooth' });
        await wait(480, t);
      }
    }
    async function moveTo(el, t) {
      await reveal(el, t);
      const [x, y] = pointOf(el);
      const d = Math.max(320, Math.min(820, Math.hypot(x - cx, y - cy) * 1.1));
      place(x, y, d); await wait(d + 60, t);
    }
    async function click(get, t) {
      let el = typeof get === 'function' ? get() : get;
      await moveTo(el, t);
      el = typeof get === 'function' ? get() : el;
      cur.classList.add('down'); el.classList.add('pressed');
      const [x, y] = pointOf(el);
      const rp = document.createElement('div'); rp.className = 'ripple'; rp.style.left = x + 'px'; rp.style.top = y + 'px';
      frame.appendChild(rp); setTimeout(() => rp.remove(), 600);
      await wait(170, t);
      cur.classList.remove('down'); el.classList.remove('pressed');
    }
    async function count(items, dur, t) {
      const n = RM ? 1 : Math.max(1, Math.round(dur / 40));
      for (let i = 1; i <= n; i++) {
        items.forEach(([el, to, fmt]) => el.textContent = (fmt || String)(Math.round(to * i / n)));
        if (i < n) await wait(40, t);
      }
    }
    let toastT;
    function toast(msg) { const e = $('toast'); e.textContent = msg; e.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(() => e.classList.remove('on'), 2300); }

    function setUrl(path) { $('url').innerHTML = '🔒 ' + path; }
    function show(view) {
      const pub = view === 'pub';
      $('app').classList.toggle('off', pub); $('v-pub').classList.toggle('on', pub);
      $('v-cap').classList.toggle('on', !pub);
      vp.scrollTop = 0;
    }
    function hideOverlays() { $('mPub').classList.remove('on'); $('notice').classList.remove('on'); $('toast').classList.remove('on'); }

    const STAGES = [
      { id: 'materials', name: 'Materials' }, { id: 'manufacturing', name: 'Manufacturing' },
      { id: 'use', name: 'Use' }, { id: 'second-life', name: 'Second life' }, { id: 'recycling', name: 'Recycling' }
    ];
    const BASE = [
      { id: 1, name: 'Identification & Metadata', desc: 'Key battery identification and manufacturing details.', stages: ['manufacturing'], fields: [['DPP ID','BP-48210'],['Manufacturer identifier','BCG-DE-5580241'],['Battery category','Industrial · above 2 kWh'],['Serial number','ESS-4812-00417'],['Production date','14 / 01 / 2027'],['Country of manufacture','Germany']] },
      { id: 2, name: 'Materials & Composition', desc: 'Chemistry, critical raw materials and hazardous substances.', stages: ['materials'], total: 3 },
      { id: 3, name: 'Carbon Footprint', desc: 'Total CO₂e and the footprint by lifecycle stage.', stages: ['manufacturing'], total: 4 },
      { id: 4, name: 'Due Diligence', desc: 'Supply-chain due diligence report under Article 52.', stages: ['materials'], total: 1 },
      { id: 5, name: 'Circularity & End-of-Life', desc: 'Recycled content, spare parts, dismantling and end-of-life handling.', stages: ['recycling'], fields: [['Recycled cobalt share','16.0 %'],['Recycled lithium share','6.0 %'],['Spare-part availability','10 years'],['Take-back scheme','Registered'],['Dismantling information','PDF · 14 pp'],['Safe-removal instructions','PDF · 6 pp']] },
      { id: 6, name: 'Performance & Durability', desc: 'Capacity, voltage, cycle life and state of health.', stages: ['use','second-life'], fields: [['Rated capacity','240 Ah'],['Nominal voltage','48 V'],['Voltage range','42.0 – 54.6 V'],['Original power capability','12 kW'],['Expected cycle life','6,000 cycles'],['Operating temperature','−20 to 55 °C'],['State of health','100 %']] },
      { id: 7, name: 'Labelling & Conformity', desc: 'Declaration of conformity, test reports, CE mark and QR label.', stages: ['manufacturing'], fields: [['EU declaration of conformity','Uploaded'],['Test reports','3 files'],['CE mark & QR carrier label','Generated']] }
    ];
    const SVG_ICON = p => `<svg class="i" viewBox="0 0 24 24">${p}</svg>`;
    const GICON = {
      1: SVG_ICON('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.01"/>'),
      2: SVG_ICON('<path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M12 12v9M4 7.5l8 4.5 8-4.5"/>'),
      3: SVG_ICON('<path d="M5 19c0-8 6-13 14-14-1 8-6 14-14 14z"/><path d="M5 19l7-7"/>'),
      4: SVG_ICON('<path d="M9 12l2 2 4-4"/><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/>'),
      5: SVG_ICON('<path d="M7 7l-3 5 3 5M4 12h9a4 4 0 0 0 4-4"/><path d="M17 17l3-5-3-5"/>'),
      6: SVG_ICON('<path d="M3 14a9 9 0 0 1 18 0"/><path d="M12 14l4-3"/><path d="M3 18h18"/>'),
      7: SVG_ICON('<path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5M10 13h6M10 17h4"/>')
    };
    const INFO = SVG_ICON('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.01"/>');
    const PEN = SVG_ICON('<path d="M4 20h4l10-10-4-4L4 16v4z"/><path d="M13.5 6.5l4 4"/>');
    const TINTS = ['t-blue','t-white','t-lilac','t-cream','t-mint','t-pink'];

    let G, openId, published = false, prevSt = {}, fresh = null;
    function seedCap(full) {
      G = BASE.map(g => g.fields
        ? { ...g, fields: g.fields.map(([n, v]) => ({ n, v, ok: full })) }
        : { ...g, done: full ? g.total : 0 });
      published = false; prevSt = {}; fresh = null;
    }
    const tot = g => g.fields ? g.fields.length : g.total;
    const don = g => g.fields ? g.fields.filter(f => f.ok).length : g.done;
    const done = g => don(g) === tot(g);

    function buildStages() {
      $('stages').innerHTML = STAGES.map(s => `<div class="stage" data-stage="${s.id}"><span class="dot"></span><span class="sb"><b>${s.name}</b><span class="state"></span><span class="mini"><i></i></span></span><span class="fc"></span></div>`).join('');
    }
    function renderCap() {
      const all = G.reduce((a, g) => a + tot(g), 0), dn = G.reduce((a, g) => a + don(g), 0);
      const gd = G.filter(done).length, full = dn === all;
      $('progLbl').textContent = `${gd} of 7 sections`;
      $('progNum').textContent = `${dn} / ${all}`;
      $('bar').style.width = (dn / all * 100) + '%';
      $('track').classList.toggle('full', full);
      const pb = $('pubBtn');
      pb.disabled = !full && !published;
      pb.className = 'btn ' + (published ? 'okb' : 'pri');
      if (!pb.dataset.busy) pb.textContent = published ? '✓ Published' : 'Publish';
      $('badge').textContent = published ? 'Published' : 'Draft';
      $('badge').classList.toggle('pubd', published);

      const WORD = { done: 'Complete', now: 'Editing now', part: 'In progress', todo: 'Not started' };
      document.querySelectorAll('#dm-stages .stage').forEach((el, i) => {
        const s = STAGES[i], gs = G.filter(g => g.stages.includes(s.id));
        const d = gs.reduce((a, g) => a + don(g), 0), t = gs.reduce((a, g) => a + tot(g), 0);
        const st = d === t ? 'done' : gs.some(g => g.id === openId) ? 'now' : d > 0 ? 'part' : 'todo';
        el.className = 'stage st-' + st;
        el.querySelector('.dot').textContent = st === 'done' ? '✓' : i + 1;
        el.querySelector('.state').textContent = WORD[st];
        el.querySelector('.mini i').style.width = (d / t * 100) + '%';
        el.querySelector('.fc').textContent = `${d}/${t}`;
        if (prevSt[s.id] && prevSt[s.id] !== st) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
        prevSt[s.id] = st;
      });

      const vid = openId ?? 1;
      $('steps').innerHTML = G.map(g => {
        const d = don(g), t = tot(g);
        const cls = d === t ? 'done' : g.id === openId ? 'now' : d > 0 ? 'part' : 'todo';
        const status = d === t ? `✓ Complete · ${d}/${t}` : d > 0 ? `${d} / ${t} fields` : 'Not started';
        return `<div class="sitem ${cls}${g.id === vid ? ' act' : ''}" data-step="${g.id}">${GICON[g.id]}<span><span class="sn">${g.name}</span><span class="ss">${status}</span></span></div>`;
      }).join('');

      const g = G.find(x => x.id === vid), d = don(g), t = tot(g);
      $('secTitle').textContent = g.name;
      $('secDesc').textContent = g.desc;
      $('secAct').innerHTML = g.fields && d < t
        ? `<button class="btn" data-request="${g.id}">Request from supplier</button><button class="edit">${PEN}Complete section</button>`
        : `<button class="edit">${PEN}Edit Section</button>`;
      $('tiles').innerHTML = g.fields
        ? g.fields.map((f, i) => f.ok
          ? `<div class="tile ${TINTS[i % 6]}${fresh === g.id + '-' + i ? ' fresh' : ''}"><div class="tlab">${INFO}${f.n}</div><div class="tval">${f.v}</div></div>`
          : `<button class="tile miss" data-g="${g.id}" data-f="${i}"><div class="tlab">${INFO}${f.n}</div><div class="tval">+ Add</div></button>`).join('')
        : `<div class="tile t-blue"><div class="tlab">${INFO}Fields captured</div><div class="tval">${d} / ${t}</div></div>`;
    }
    function fill(gid, i) { const g = G.find(x => x.id === gid); g.fields[i].ok = true; fresh = gid + '-' + i; $('saved').textContent = '✓ Saved just now'; }

    function qrSvg(el, animate) {
      let s = 7, cells = '';
      const rnd = () => (s = (s * 9301 + 49297) % 233280) / 233280;
      const finder = (x, y) => (x < 7 && y < 7) || (x > 17 && y < 7) || (x < 7 && y > 17);
      const fp = (x, y) => { const ax = x > 17 ? x - 18 : x, ay = y > 17 ? y - 18 : y; return ax === 0 || ax === 6 || ay === 0 || ay === 6 || (ax > 1 && ax < 5 && ay > 1 && ay < 5); };
      for (let y = 0; y < 25; y++) for (let x = 0; x < 25; x++) {
        const on = finder(x, y) ? fp(x, y) : (x < 8 && y < 8) || (x > 16 && y < 8) || (x < 8 && y > 16) ? false : rnd() > .52;
        if (on) cells += `<rect class="m" x="${x}" y="${y}" width="1" height="1" fill="#0E1A3A" style="transition-delay:${animate ? Math.round(rnd() * 650) : 0}ms"/>`;
      }
      el.innerHTML = cells;
    }

    const YEARS = { materials: '2026', manufacturing: '2027', use: '2027 →', 'second-life': '2035 →', recycling: '2042' };
    let pubHere = 2;
    function renderPub() {
      $('pstages').innerHTML = STAGES.map((s, i) => `<div class="pst ${i < pubHere ? 'past' : i === pubHere ? 'here' : ''}"><span class="dot">${i < pubHere ? '✓' : ''}</span><b>${s.name}</b><span>${i <= pubHere ? YEARS[s.id] : '—'}</span></div>`).join('');
      document.querySelectorAll('#dm-prail .seg').forEach((seg, i) => seg.classList.toggle('on', i < pubHere));
    }
    function addEvent(year, text) {
      const ev = document.createElement('div'); ev.className = 'ev'; ev.innerHTML = `<i>${year}</i><span>${text}</span>`;
      const box = $('events'); box.prepend(ev); while (box.children.length > 4) box.lastChild.remove();
    }

    const SCENES = [
      { title: 'Publish', desc: 'Publishing mints the QR code and carrier label that travel with the battery.', run: async t => {
        hideOverlays();
        if (!G || G.some(g => !done(g))) { seedCap(true); openId = null; buildStages(); }
        show('cap'); setUrl('app.provinyx.com/master-data/<b>BP-48210</b>'); renderCap();
        await wait(600, t);
        await click($('pubBtn'), t);
        $('pubBtn').dataset.busy = '1'; $('pubBtn').textContent = 'Publishing…'; await wait(1000, t);
        delete $('pubBtn').dataset.busy; published = true; renderCap();
        qrSvg($('qrBig'), true); $('qrBig').classList.remove('show');
        $('mPub').classList.add('on'); await wait(120, t); $('qrBig').classList.add('show');
        await wait(1900, t);
        await click($('viewPubBtn'), t);
        $('mPub').classList.remove('on');
      }},
      { title: 'Capture the data', desc: 'Import what you hold, fill the gaps, request the rest from suppliers — the lifecycle updates live.', run: async t => {
        hideOverlays(); seedCap(false); openId = 5; show('cap'); setUrl('app.provinyx.com/master-data/<b>BP-48210</b>');
        buildStages(); $('saved').textContent = '✓ Saved'; $('importBtn').textContent = 'Import from ERP'; renderCap();
        await wait(800, t);
        await click($('importBtn'), t);
        $('importBtn').textContent = 'Importing…';
        const circ = G.find(g => g.id === 5);
        for (let k = 1; k <= 22; k++) {
          const f = k / 22;
          G.slice(0, 4).forEach(g => {
            if (g.fields) g.fields.forEach((x, i) => { if (f >= (i + 1) / g.fields.length) x.ok = true; });
            else g.done = Math.round(g.total * f);
          });
          circ.fields.forEach((x, i) => { if (i < 4 && f >= (i + 1) / 5) x.ok = true; });
          renderCap(); await wait(RM ? 0 : 55, t);
        }
        $('importBtn').textContent = '✓ Imported'; $('saved').textContent = '✓ Saved just now';
        toast('Imported 18 fields from your ERP'); await wait(1100, t);
        for (const i of [4, 5]) {
          await click(() => document.querySelector(`[data-g="5"][data-f="${i}"]`), t);
          fill(5, i); renderCap(); await wait(420, t);
        }
        toast('Circularity complete — Recycling stage updated'); await wait(1200, t);
        openId = 6; fresh = null; renderCap(); await wait(500, t);
        await click(() => document.querySelector('[data-request="6"]'), t);
        toast('Request sent to Nordcell AB, your cell supplier'); await wait(1400, t);
        $('notice').classList.add('on'); await wait(700, t);
        for (let i = 0; i < 7; i++) { fill(6, i); renderCap(); await wait(RM ? 0 : 180, t); }
        await wait(500, t); $('notice').classList.remove('on');
        toast('Performance complete — Use and Second life updated'); await wait(1200, t);
        openId = 7; fresh = null; renderCap(); await wait(500, t);
        for (let i = 0; i < 3; i++) {
          await click(() => document.querySelector(`[data-g="7"][data-f="${i}"]`), t);
          fill(7, i); renderCap(); await wait(280, t);
        }
        openId = null; fresh = null; renderCap();
        toast('All 30 fields captured — ready to publish');
        vp.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' });
        await wait(1400, t);
      }},
      { title: 'Follow the battery', desc: 'One scan shows the passport — and it travels with the battery through its whole life.', run: async t => {
        hideOverlays(); show('pub'); setUrl('passport.provinyx.com/<b>BP-48210</b>');
        qrSvg($('qrSmall'), false);
        pubHere = 2; $('soh').textContent = '100'; $('tl').classList.remove('looped'); $('sohF').classList.remove('hot');
        $('events').innerHTML = ''; addEvent('2026', 'Raw materials sourced — due diligence verified'); addEvent('2027', 'Manufactured in Rostock, DE — passport published');
        renderPub(); place(1010, 600, 500);
        await wait(1800, t);
        const legs = [
          { here: 3, soh: 78, year: '2035', ev: 'Repurposed for home storage — ownership transferred' },
          { here: 4, soh: 61, year: '2042', ev: 'Collected by a certified recycler — cobalt and lithium recovered' }
        ];
        for (const L of legs) {
          pubHere = L.here; renderPub(); $('sohF').classList.add('hot');
          await count([[$('soh'), L.soh]], 900, t);
          $('sohF').classList.remove('hot');
          addEvent(L.year, L.ev);
          await wait(1500, t);
        }
        $('tl').classList.add('looped'); addEvent('2043', 'Recovered materials return to new cells — the loop closes');
        await wait(2600, t);
      }}
    ];

    $('pdots').innerHTML = SCENES.map((s, i) => `<button class="pd" data-i="${i}" aria-label="Show: ${s.title}"></button>`).join('');
    function caption(i) {
      $('capT').textContent = SCENES[i].title; $('capD').textContent = SCENES[i].desc;
      document.querySelectorAll('#dm-pdots .pd').forEach(d => d.classList.toggle('on', +d.dataset.i === i));
    }
    async function play(from) {
      const t = ++token; let i = from;
      try { while (true) { caption(i); await SCENES[i].run(t); i = (i + 1) % SCENES.length; } }
      catch (e) { if (!(e instanceof Cancel)) console.error(e); }
    }
    $('pdots').addEventListener('click', e => { const d = e.target.closest('.pd'); if (!d) return; setPaused(false); play(+d.dataset.i); });
    $('pp').addEventListener('click', () => setPaused(!paused));

    setPaused(paused);
    buildStages();
    play(0);

    // embedded: keep playing forever, but rest while scrolled out of view
    if (embedded && !RM && typeof IntersectionObserver !== 'undefined') {
      io = new IntersectionObserver(([e]) => setPaused(!e.isIntersecting), { threshold: 0.1 });
      io.observe(wrap);
    }

    return () => {
      token = Number.MAX_SAFE_INTEGER;
      window.removeEventListener('resize', fit);
      if (ro) ro.disconnect();
      if (io) io.disconnect();
      clearTimeout(toastT);
    };
  }, []);

  return (
    <div className={"dm-root" + (embedded ? " dm-embed" : "")} style={whiteBg ? { background: "#fff" } : undefined}>
      <style dangerouslySetInnerHTML={{ __html: DM_CSS }} />
      <div className="wrap" id="dm-wrap" style={{ maxWidth }}>
        <div className="frame" id="dm-frame">
          <div className="bar">
            <div className="dots">
              <i style={{background:'#F2655A'}}></i>
              <i style={{background:'#F6BF4F'}}></i>
              <i style={{background:'#61C454'}}></i>
            </div>
            <div className="url" id="dm-url">🔒 app.provinyx.com/master-data/<b>BP-48210</b></div>
            <div style={{width:'56px',flex:'none'}}></div>
          </div>
          <div className="app" id="dm-app">
            <header className="topnav">
              <img className="logo" src={logo} alt="Provinyx" />
              <nav className="tnav">
                <button className="nav"><svg className="i" viewBox="0 0 24 24"><rect x="3.5" y="3.5" width="7" height="8" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="5" rx="1.5"/><rect x="3.5" y="14.5" width="7" height="6" rx="1.5"/><rect x="13.5" y="11.5" width="7" height="9" rx="1.5"/></svg>Dashboard</button>
                <button className="nav on"><svg className="i" viewBox="0 0 24 24"><ellipse cx="12" cy="5.5" rx="6.5" ry="2.5"/><path d="M5.5 5.5v13c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5v-13"/><path d="M5.5 10c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5M5.5 14.5c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5"/></svg>Master Data</button>
                <button className="nav"><svg viewBox="0 0 24 24" aria-hidden="true" fill="#fff"><path d="M3 7.2h12.5V4.2L21 8.6l-5.5 4.4v-3H3z"/><path d="M21 16.8H8.5v3L3 15.4l5.5-4.4v3H21z"/></svg>Transaction</button>
                <button className="nav"><svg className="i" viewBox="0 0 24 24"><path d="M12 2.8l7.5 3v5.6c0 4.7-3.2 8.3-7.5 10.2-4.3-1.9-7.5-5.5-7.5-10.2V5.8z"/></svg>Authenticator</button>
                <button className="nav"><svg className="i" viewBox="0 0 24 24"><path d="M6 10a6 6 0 0 1 12 0c0 5 2 6.5 2 6.5H4S6 15 6 10z"/><path d="M10 20a2 2 0 0 0 4 0"/></svg>Notifications</button>
                <button className="nav"><svg className="i" viewBox="0 0 24 24"><path d="M12 15V3.5m0 0L7.5 8m4.5-4.5L16.5 8"/><path d="M4 14v5.5h16V14"/></svg>Upload Data</button>
                <button className="nav"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="#fff"/><circle cx="12" cy="9.3" r="3.3" fill="#3370E0"/><path d="M5.8 18.3c1.3-2.4 3.5-3.6 6.2-3.6s4.9 1.2 6.2 3.6A8.4 8.4 0 0 1 12 20.6a8.4 8.4 0 0 1-6.2-2.3z" fill="#3370E0"/></svg>Profile</button>
              </nav>
            </header>
            <main className="vp" id="dm-vp">
              <div className="view" id="dm-v-cap">
                <div className="dsub">
                  <span className="back"><svg className="i" viewBox="0 0 24 24"><path d="M19 12H5m0 0l6-6m-6 6l6 6"/></svg>Back</span>
                  <div className="did">DPP ID: <b>BP-48210</b><span className="badge" id="dm-badge">Draft</span></div>
                  <div className="sp">
                    <span className="saved" id="dm-saved">✓ Saved</span>
                    <button className="btn" id="dm-importBtn">Import from ERP</button>
                    <button className="btn"><svg className="i" viewBox="0 0 24 24"><path d="M12 3v12m0 0l-4-4m4 4l4-4"/><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/></svg>Download</button>
                    <button className="btn"><svg className="i" viewBox="0 0 24 24"><circle cx="6" cy="12" r="2.4"/><circle cx="18" cy="6" r="2.4"/><circle cx="18" cy="18" r="2.4"/><path d="M8 11l8-4M8 13l8 4"/></svg>Share</button>
                    <button className="btn pri" id="dm-pubBtn" disabled>Publish</button>
                  </div>
                </div>
                <div className="dbody">
                  <aside className="srail">
                    <div className="prog">
                      <div className="lbl"><span id="dm-progLbl"></span><b id="dm-progNum"></b></div>
                      <div className="track" id="dm-track"><i id="dm-bar"></i></div>
                    </div>
                    <div className="steps" id="dm-steps"></div>
                  </aside>
                  <div className="mcard">
                    <div className="mhead">
                      <h1 id="dm-secTitle"></h1>
                      <span className="star"><svg className="i" viewBox="0 0 24 24"><path d="M12 4l2.3 4.7 5.2.7-3.8 3.6.9 5.2-4.6-2.5-4.6 2.5.9-5.2L4.5 9.4l5.2-.7z"/></svg></span>
                      <div className="mact" id="dm-secAct"></div>
                    </div>
                    <p className="mdesc" id="dm-secDesc"></p>
                    <div className="tiles" id="dm-tiles"></div>
                  </div>
                  <aside className="ppanel">
                    <div className="pimgbox">
                      <svg viewBox="0 0 120 150" aria-hidden="true">
                        <defs><linearGradient id="dm-bat" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#3A63EA"/><stop offset="1" stopColor="#22429C"/></linearGradient></defs>
                        <rect x="10" y="22" width="100" height="122" rx="14" fill="url(#dm-bat)"/>
                        <rect x="36" y="10" width="48" height="16" rx="6" fill="#22429C"/>
                        <rect x="24" y="36" width="72" height="8" rx="4" fill="#fff" opacity=".85"/>
                        <rect x="24" y="52" width="50" height="6" rx="3" fill="#fff" opacity=".5"/>
                        <path d="M66 70 L44 102 H58 L52 128 L78 92 H63 Z" fill="#fff"/>
                      </svg>
                    </div>
                    <div className="prow"><span className="picon pi-blue"><svg className="i" viewBox="0 0 24 24"><path d="M3 8l9-5 9 5-9 5-9-5z"/><path d="M3 8v8l9 5 9-5V8"/></svg></span><div><div className="plab">Product name</div><div className="pval">Industrial ESS 48V / 12 kWh</div></div></div>
                    <div className="prow"><span className="picon pi-lilac"><svg className="i" viewBox="0 0 24 24"><path d="M4 21V8l8-5 8 5v13"/><path d="M9 21v-6h6v6"/></svg></span><div><div className="plab">Manufacturer</div><div className="pval">Baltic Cell GmbH</div></div></div>
                    <div className="lifeh"><h3>Battery lifecycle</h3><span className="livebadge"><i></i>Live</span></div>
                    <div className="vstages" id="dm-stages"></div>
                  </aside>
                </div>
              </div>
            </main>
          </div>
          <div className="public" id="dm-v-pub">
            <div className="ph">
              <img className="plogo" src={logo} alt="Provinyx" />
              <span className="phs">Battery passport</span>
              <span className="ver">✓ Verified · EU Battery Regulation</span>
              <span className="scan">scanned just now</span>
            </div>
            <div className="pbody">
              <div className="phero">
                <div>
                  <span className="cat">Industrial battery · above 2 kWh</span>
                  <h2>Industrial ESS 48V / 12 kWh</h2>
                  <div className="pm">Baltic Cell GmbH · DPP ID <b>BP-48210</b> · LFP chemistry</div>
                </div>
                <svg className="qrs" id="dm-qrSmall" viewBox="0 0 25 25"></svg>
              </div>
              <div className="facts6">
                <div className="fact t-blue"><div className="k">Carbon footprint</div><div className="v">58 <small>kg CO₂e/kWh</small></div></div>
                <div className="fact t-lilac"><div className="k">Recycled cobalt</div><div className="v">16 <small>%</small></div></div>
                <div className="fact t-cream"><div className="k">Recycled lithium</div><div className="v">6 <small>%</small></div></div>
                <div className="fact t-mint"><div className="k">Rated capacity</div><div className="v">240 <small>Ah</small></div></div>
                <div className="fact t-pink"><div className="k">Expected cycle life</div><div className="v">6,000</div></div>
                <div className="fact t-white" id="dm-sohF"><div className="k">State of health</div><div className="v"><span id="dm-soh">100</span> <small>%</small></div></div>
              </div>
              <div className="plife">
                <div className="pbox">
                  <h3>Life of this battery</h3>
                  <p className="ps">The passport moves with the battery through every owner and stage</p>
                  <div className="tl" id="dm-tl">
                    <div className="loop"><span className="loop-lbl">recovered materials return to new cells</span><span className="loop-arr"></span></div>
                    <div className="rail" id="dm-prail"><i className="seg"></i><i className="seg"></i><i className="seg"></i><i className="seg"></i></div>
                    <div className="stages" id="dm-pstages"></div>
                  </div>
                </div>
                <div className="pbox"><h3>Passport history</h3><p className="ps">Every change is recorded</p><div className="events" id="dm-events"></div></div>
              </div>
            </div>
          </div>
          <div className="overlay" id="dm-mPub">
            <div className="card pubcard">
              <div className="okc">✓</div>
              <h3>Passport published</h3>
              <p className="cs">BP-48210 is live. The QR code and carrier label are ready to print.</p>
              <div className="qrbox"><svg className="qr" id="dm-qrBig" viewBox="0 0 25 25"></svg></div>
              <div className="cardfoot"><button className="btn">Download label</button><button className="btn pri" id="dm-viewPubBtn">View public passport</button></div>
            </div>
          </div>
          <div className="notice" id="dm-notice"><div className="ic">⇣</div><div><b>Nordcell AB shared 7 fields</b><span>Performance data for cell lot C-7719</span></div></div>
          <div className="toast" id="dm-toast"></div>
          <svg className="cursor" id="dm-cur" viewBox="0 0 22 26" aria-hidden="true">
            <path d="M2 2 L2 21 L7.2 16.4 L10.6 24 L14 22.5 L10.7 15 L18 15 Z" fill="#0E1A3A" stroke="#fff" strokeWidth="1.6" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
      <div className="player" style={{ maxWidth }}>
        <button className="pp" id="dm-pp" aria-label="Pause">❚❚</button>
        <div className="pdots" id="dm-pdots"></div>
        <div className="pcap" aria-live="polite"><b id="dm-capT"></b><span id="dm-capD"></span></div>
      </div>
      {!embedded && (
      <div style={{textAlign:'center',marginTop:'12px'}}>
        <button id="dm-sampleBtn" type="button" aria-haspopup="dialog" onClick={() => setShowSample(true)} style={{display:'inline-flex',alignItems:'center',gap:'8px',padding:'10px 22px',borderRadius:'12px',background:'#2F57E6',color:'#fff',fontSize:'13.5px',fontWeight:600,border:'none',cursor:'pointer',boxShadow:'0 4px 16px rgba(47,87,230,.35)'}}>
          <svg style={{width:'16px',height:'16px'}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
          </svg>
          See a sample passport
        </button>
      </div>
      )}
      {!embedded && showSample && <SamplePassport onClose={() => setShowSample(false)} />}
      {/* <p className="note">Concept animation · fictional company and figures · Provinyx battery passport</p> */}
    </div>
  );
}